define('widgets/olark/helper/olarkOperator',[
    'knockout',
    'underscore',
    'jquery',
    'widgets/olark/helper/olarkSelectors',
    'common/tools'
], function (ko, _, $, olarkSelectors, tools) {
    var olarkOperator = function (olarkStorage) {
        var self = this,
            memoizeInjectStyles = _.memoize(injectStyles);

        function messageObjectsLength() {
            return _.size(getMessageObjects());
        }

        function getOperatorKey(operatorKey) {
            return operatorKey.split(':')[0];
        }

        function getOperatorAvatarURLFromStorage(operatorName) {
            return _.result(_.find(olarkStorage(), {
                name: operatorName
            }), 'avatarURL') || olarkSelectors.DEFAULT_AVATAR;
        }

        function setOperatorAvatarURLInStorage(operatorName, avatarURL) {
            var operator = {
                avatarURL: avatarURL,
                name: operatorName
            },
            storage = _.isArray(olarkStorage()) && olarkStorage() || [];

            !_.find(olarkStorage(), {
                name: operatorName
            }) && olarkStorage(storage.concat(operator));
        }

        function getAvatarURL(hasAvatar, operatorName) {
            if (hasAvatar) {
                setOperatorAvatarURLInStorage(operatorName, hasAvatar);
                return hasAvatar;
            }
            return getOperatorAvatarURLFromStorage(operatorName);
        }

        function uniqueNameAvatarPairs(messageObjects) {
            return _.uniq(
                        _.map(messageObjects, function (v, index) {
                            var operatorName = getOperatorKey(
                                    $(v).find(olarkSelectors.OLARK_OPERATOR_NAME).text()
                                ),
                                hasAvatar = _.result(_.first($(v).find('img')), 'src'),
                                avatarURL = getAvatarURL(hasAvatar, operatorName);

                            return {
                                avatarURL: avatarURL,
                                name: operatorName
                            };
                        }), 'name');
        };

        function injectStyles(styles) {
            $('#olark-styles').length ?
            $('#olark-styles').text(styles) :
            $('<style id=\'olark-styles\' >' + styles + '</style>').appendTo(document.head);
        }

        function buildStylesForBackgroundImage(operator) {
            return _.template(olarkSelectors.OLARK_OPERATOR_DYNAMIC_BACKGROUND)({
                name: operator.name,
                avatarURL: operator.avatarURL
            });
        }

        function addDynamicCssClass(operators) {
            return _.map(operators, function (operator) {
                        if (!_.isEmpty(operator.avatarURL)) {
                            $(_.template(olarkSelectors.OLARK_UNIQUE_NAME_AVATAR_PAIRS)({
                                name: operator.name
                            })).addClass('olark-person2').addClass('olark-' + operator.name);

                            return buildStylesForBackgroundImage(operator);
                        }
                    }).join('\n');
        }

        function getMessageObjects() {
            return $(olarkSelectors.OLARK_OPERATOR_MESSAGES);
        };

        function buildStylesForLastMessage(avatarURL) {
            return !_.isEmpty(avatarURL) ?
                    _.template(olarkSelectors.OLARK_OPERATOR_LAST_MESSAGE_BACKGROUND)({
                        avatarURL: avatarURL
                    }) :
                    _.template(olarkSelectors.OLARK_OPERATOR_BACKGROUND_NONE)();
        }

        function getLastOperatorName(messageObjects) {
            return $(_.last(messageObjects)).find(olarkSelectors.OLARK_OPERATOR_NAME).text();
        }

        function getLastAvatarURL(messageObjects) {
            return _.flowRight(
                getOperatorAvatarURLFromStorage, getOperatorKey, getLastOperatorName
                )(messageObjects);
        }

        self.init = function () {
            var messageObjects = getMessageObjects();

            memoizeInjectStyles(_.reduce([
                _.flowRight(addDynamicCssClass, uniqueNameAvatarPairs),
                _.flowRight(buildStylesForLastMessage, getLastAvatarURL)
            ], function (prev, current) {
                return prev + ' ' + current(messageObjects);
            }, ''));
        }

        self.appendStylesForNewMessage = function (operatorName) {
            var messageObjects = getMessageObjects();

            if (!_.isEmpty(getOperatorAvatarURLFromStorage(operatorName))) {
                memoizeInjectStyles(
                    _.flowRight(addDynamicCssClass, uniqueNameAvatarPairs)(messageObjects)  + ' ' +
                    _.flowRight(buildStylesForLastMessage, getOperatorAvatarURLFromStorage)
                    (operatorName));
            } else {
                tools.waitUntil(function () {
                    return messageObjects.length + 1 === messageObjectsLength();
                }).then(function () {
                    memoizeInjectStyles(
                        _.flowRight(addDynamicCssClass, uniqueNameAvatarPairs)(getMessageObjects())
                        + ' ' +
                        _.flowRight(
                            buildStylesForLastMessage, getOperatorAvatarURLFromStorage
                        )(operatorName)
                    );
                });
            }
        }

    };

    return olarkOperator;

});

